import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { SmtpConfigService } from "../../core/service/smtp-config.service";
import { SmtpConfig } from "../../core/model/smtp-config";

@Component({
  selector: "app-add-smtp-config",
  templateUrl: "./add-smtp-config.component.html",
  styleUrls: ["./add-smtp-config.component.scss"],
})
export class AddSmtpConfigComponent implements OnInit {
  smtp: SmtpConfig = new SmtpConfig();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _smtpConfigService: SmtpConfigService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      host: [null, Validators.compose([Validators.required])],
      port: [null, Validators.compose([Validators.required])],
      starttls: [null, Validators.compose([Validators.required])],
      username: [null, Validators.compose([Validators.required])],
      password: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._smtpConfigService
      .postSmtp(this.smtp)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
